import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import Store from './store';
import Layout from '../layout';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';

const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');

const DownloadModal = ({ store, onClose }) => {
  store.use();

  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <React.Fragment>
      <Layout className={cx(styles.downloadModalRoot)} isOpen={store.isOpen} onClose={store.onClickClose}>
        <div className={cx(styles.content)}>
          {/* <div className={styles.tipBox}>
            <div className={styles.prefix} />
            <p className={cx(styles.tip)}>{`[ ${pageLocalesData.downloadModal.text1} ]`}</p>
            <div className={styles.suffix} />
          </div> */}
          {/* <div className={styles.mechabreak}>{pageLocalesData.downloadModal.text4}</div> */}
          <div className={styles.tip2}>{pageLocalesData.downloadModal.text1}</div>
          <div className={cx(styles.btnBook)}>
            <Link className={styles.btnCopy} onClick={() => store.copyLink()}>
              {pageLocalesData.downloadModal.btnText}
            </Link>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default wrapStore(DownloadModal, Store);
